import { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

interface ParticipantInfo {
  firstName: string;
  lastName: string;
  email: string;
}

export function NewSession() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = searchParams.get('id');

  const [mentor, setMentor] = useState<ParticipantInfo>({
    firstName: '',
    lastName: '',
    email: '',
  });

  const [mentee, setMentee] = useState<ParticipantInfo>({
    firstName: '',
    lastName: '',
    email: '',
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (sessionId) {
      navigate(`/session/${sessionId}`, { 
        state: { mentor, mentee }
      });
    }
  };

  return (
    <div className="max-w-2xl mx-auto">
      <h1 className="text-3xl font-bold mb-8">New Mentorship Session</h1>
      <form onSubmit={handleSubmit} className="space-y-8">
        <div className="bg-white p-6 rounded-lg shadow-sm border">
          <h2 className="text-xl font-semibold mb-4">Mentor Details</h2>
          <div className="space-y-4">
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label htmlFor="mentorFirstName" className="block text-sm font-medium text-gray-700 mb-1">
                  First Name
                </label>
                <input
                  type="text"
                  id="mentorFirstName"
                  value={mentor.firstName}
                  onChange={(e) => setMentor({ ...mentor, firstName: e.target.value })}
                  className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-[#ffcc32] focus:border-[#ffcc32] outline-none"
                  required
                />
              </div>
              <div>
                <label htmlFor="mentorLastName" className="block text-sm font-medium text-gray-700 mb-1">
                  Last Name
                </label>
                <input
                  type="text"
                  id="mentorLastName"
                  value={mentor.lastName}
                  onChange={(e) => setMentor({ ...mentor, lastName: e.target.value })}
                  className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-[#ffcc32] focus:border-[#ffcc32] outline-none"
                  required
                />
              </div>
            </div>
            <div>
              <label htmlFor="mentorEmail" className="block text-sm font-medium text-gray-700 mb-1">
                Email
              </label>
              <input
                type="email"
                id="mentorEmail"
                value={mentor.email}
                onChange={(e) => setMentor({ ...mentor, email: e.target.value })}
                className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-[#ffcc32] focus:border-[#ffcc32] outline-none"
                required
              />
            </div>
          </div>
        </div>

        <div className="bg-white p-6 rounded-lg shadow-sm border">
          <h2 className="text-xl font-semibold mb-4">Mentee Details</h2>
          <div className="space-y-4">
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label htmlFor="menteeFirstName" className="block text-sm font-medium text-gray-700 mb-1">
                  First Name
                </label>
                <input
                  type="text"
                  id="menteeFirstName"
                  value={mentee.firstName}
                  onChange={(e) => setMentee({ ...mentee, firstName: e.target.value })}
                  className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-[#ffcc32] focus:border-[#ffcc32] outline-none"
                  required
                />
              </div>
              <div>
                <label htmlFor="menteeLastName" className="block text-sm font-medium text-gray-700 mb-1">
                  Last Name
                </label>
                <input
                  type="text"
                  id="menteeLastName"
                  value={mentee.lastName}
                  onChange={(e) => setMentee({ ...mentee, lastName: e.target.value })}
                  className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-[#ffcc32] focus:border-[#ffcc32] outline-none"
                  required
                />
              </div>
            </div>
            <div>
              <label htmlFor="menteeEmail" className="block text-sm font-medium text-gray-700 mb-1">
                Email
              </label>
              <input
                type="email"
                id="menteeEmail"
                value={mentee.email}
                onChange={(e) => setMentee({ ...mentee, email: e.target.value })}
                className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-[#ffcc32] focus:border-[#ffcc32] outline-none"
                required
              />
            </div>
          </div>
        </div>

        <div className="flex justify-end">
          <button
            type="submit"
            className="bg-[#ffcc32] text-black font-medium px-6 py-3 rounded-lg hover:bg-[#ffd65c] transition-colors"
          >
            Create Session
          </button>
        </div>
      </form>
    </div>
  );
}